// `portal={false}` for a menu in a drawer (finance-real, 2026-10-22), which DD-051 keeps inside the drawer's content: a
// menu portalled to <body> under a modal drawer takes no click or key.
import { KeyboardEvent, MouseEvent } from "react";
import { DotsVerticalIcon } from "@/components/icons";
import { DropdownMenu, type DropdownMenuEntry } from "@/components/ui/DropdownMenu";

/**
 * A row's context menu of quick actions (DD-045). Each action opens its own modal, or the row's modal
 * at that step. Renders nothing when the row has no actions. The menu sits in a portal so a
 * scrolling table never clips it, and a click on it never counts as a row click.
 */
export function RowMenu({ items, label = "Actions", portal = true, width }: { items: DropdownMenuEntry[]; label?: string; portal?: boolean; width?: string }) {
  if (items.length === 0) return null;
  const stop = (e: MouseEvent | KeyboardEvent) => e.stopPropagation();
  return (
    <div onClick={stop} onKeyDown={stop} className="flex justify-end">
      <DropdownMenu
        items={items}
        // In a drawer it sizes to its longest item, up to about the drawer's width, and wraps beyond that.
        width={width ?? (portal ? "w-52" : "w-max max-w-[min(28rem,calc(100vw-4rem))]")}
        wrap={!portal}
        align="right"
        portal={portal}
        menuClassName="rounded-xl"
        trigger={
          <button type="button" aria-label={label} className="p-1.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
            <DotsVerticalIcon className="w-4 h-4" />
          </button>
        }
      />
    </div>
  );
}
